import { useEffect, useState } from 'react';

const FAQHero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-b from-luxury-black via-luxury-black to-luxury-ivory overflow-hidden">
      {/* Decorative Lines */}
      <div className="absolute top-0 left-0 w-full h-px">
        <div 
          className={`h-full bg-gradient-to-r from-transparent via-gold-400/30 to-transparent transition-all duration-1000 ${
            isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`}
        ></div>
      </div>
      <div className="absolute bottom-0 left-0 w-full h-px">
        <div 
          className={`h-full bg-gradient-to-r from-transparent via-gold-400/30 to-transparent transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`}
        ></div>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle at 2px 2px, rgba(212, 175, 55, 0.3) 1px, transparent 0)',
            backgroundSize: '48px 48px',
          }}
        ></div>
      </div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div 
            className={`inline-flex items-center gap-2 px-5 py-2 bg-gold-400/10 border border-gold-400/30 rounded-full mb-8 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <i className="ri-question-line text-gold-400"></i>
            <span className="text-gold-400 font-medium text-sm tracking-wide">Perguntas Frequentes</span>
          </div>

          {/* Title */}
          <h1 
            className={`font-['Playfair_Display'] text-5xl md:text-6xl lg:text-7xl font-bold mb-6 transition-all duration-700 delay-100 ${
              isVisible ? 'opacity-100 translate-y-0 blur-0 scale-100' : 'opacity-0 translate-y-8 blur-sm scale-95'
            }`}
          >
            <span className="text-white">Tire Suas</span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 via-gold-300 to-gold-400">
              Dúvidas
            </span>
          </h1>

          {/* Description */}
          <p 
            className={`font-['Montserrat'] text-lg md:text-xl text-white/70 leading-relaxed max-w-2xl mx-auto transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            Encontre respostas para as perguntas mais comuns sobre o Carta do Eu Futuro. 
            Estamos aqui para ajudar você em sua jornada de transformação.
          </p>

          {/* Decorative Element */}
          <div 
            className={`mt-12 flex items-center justify-center gap-3 transition-all duration-700 delay-300 ${
              isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
            }`}
          >
            <div className="w-16 h-px bg-gradient-to-r from-transparent to-gold-400/50"></div>
            <div className="w-2 h-2 rounded-full bg-gold-400"></div>
            <div className="w-16 h-px bg-gradient-to-l from-transparent to-gold-400/50"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQHero;
